import type { IScoreSection, IDynamicContent } from '../common-types';

/**
 * getScoreSections from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param dynamicContent - The dynamic content to get the score sections from.
 * @param scoreSections - The score sections to get the dynamic content for.
 * @returns The score sections with the dynamic content.
 */

export const getScoreSections = (
  scoreSections: IScoreSection[],
  dynamicContent?: IDynamicContent
) => {
  if (
    dynamicContent === undefined ||
    !Array.isArray(dynamicContent.dynamicContentSection)
  ) {
    return scoreSections;
  }

  return scoreSections.map((sc) => {
    const dynamicContentSection = dynamicContent.dynamicContentSection.find(
      (s) =>
        s.sectionName.replace(/\s+/g, '').toLocaleLowerCase() ===
        sc.name?.replace(/\s+/g, '').toLocaleLowerCase()
    );

    return {
      ...sc,
      htmlContent:
        dynamicContentSection !== undefined
          ? dynamicContentSection?.htmlContent
              ?.sort(function (a, b) {
                return a.order - b.order;
              })
              ?.map((dc) => {
                return dc.content;
              })
              .join('')
              .trim()
          : undefined,
    };
  });
};
